import React, { useState } from "react";
import { useLang } from "../lib/lang-context";
import { WhatsappLogo, X } from "@phosphor-icons/react";
import { WHATSAPP_NUMBER } from "../lib/i18n";

export default function WhatsAppFab() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    t.whatsapp.message
  )}`;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {open && (
        <div
          data-testid="whatsapp-tooltip"
          className="bg-white dark:bg-zinc-900 text-slate-900 dark:text-white text-sm border border-slate-200 dark:border-zinc-700 px-4 py-3 max-w-[250px] shadow-lg animate-fade-up"
          style={{ borderRadius: 6 }}
        >
          <div className="font-medium mb-1 text-[var(--icor-navy)] dark:text-white">
            {t.whatsapp.tooltip}
          </div>
          <div className="text-xs text-slate-500 dark:text-zinc-400">
            {t.contact.phone}
          </div>
        </div>
      )}
      <div className="flex items-center gap-2">
        {open && (
          <button
            onClick={() => setOpen(false)}
            aria-label="Close"
            className="w-9 h-9 flex items-center justify-center bg-white dark:bg-zinc-900 border border-slate-200 dark:border-zinc-700 text-slate-500 hover:text-slate-900 dark:hover:text-white rounded-full transition-all"
          >
            <X size={16} />
          </button>
        )}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={() => setOpen(true)}
          data-testid="whatsapp-fab"
          className="w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-xl transition-all duration-300 hover:scale-105 hover:-translate-y-0.5"
          aria-label={t.whatsapp.label}
        >
          <WhatsappLogo size={28} weight="fill" />
        </a>
      </div>
    </div>
  );
}
